export const mutations = {
  setProvince: function (state, data) {
    state.province = data;
  },
};
